import { Link } from 'react-router-dom';

export default function Footer() {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="sm:col-span-2 md:col-span-1">
            <div className="bg-emerald-500 px-4 md:px-6 py-1.5 md:py-2 rounded-full inline-block mb-4">
              <span className="text-white font-bold text-sm md:text-lg">
                (주)그린디자인테크
              </span>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">바로가기</h3>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <Link 
                  to="/" 
                  onClick={handleLinkClick}
                  className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  홈
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  onClick={handleLinkClick}
                  className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  회사소개
                </Link>
              </li>
              <li>
                <Link 
                  to="/products" 
                  onClick={handleLinkClick}
                  className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  제품
                </Link>
              </li>
              <li>
                <Link 
                  to="/catalog" 
                  onClick={handleLinkClick}
                  className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  카달로그
                </Link>
              </li>
              <li>
                <Link 
                  to="/gallery" 
                  onClick={handleLinkClick}
                  className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer text-sm md:text-base"
                >
                  현장사진 갤러리
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div className="sm:col-span-2 md:col-span-1">
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">상담문의</h3>
            <div className="space-y-3 md:space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-fill text-white text-sm"></i>
                </div>
                <span className="text-gray-300 text-sm md:text-base break-all">steng2021@naver.com</span>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-teal-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-fill text-white text-sm"></i>
                </div>
                <span className="text-gray-300 text-sm md:text-base">031) 989-7136</span>
              </div>
            </div>
          </div>

          {/* Newsletter - Empty placeholder */}
          <div className="hidden md:block">
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 md:mt-12 pt-6 md:pt-8">
          <div className="text-gray-400 text-xs md:text-sm text-center">
            © 2024 Kate Wolff. All rights reserved. Made with ❤️ and creativity. | <a href="https://readdy.ai/?ref=logo" className="hover:text-emerald-400 transition-colors">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
